import { api } from '@/scripts/api';
export const NotificationWidgetService = {

    get(type, offset, limit){
        return new Promise((resolve, reject) => {
            const service = '/ms/notifications/v1/';
            let path = '';
            switch (type){
                case 'mine':
                    path ='notifications';
                    break;
                case 'sales':
                    path ='notifications/sales';
                    break;
                case 'updates':
                    path ='updates';
                    break;
            }
            const endpoint = `${service}${path}?offset=${offset}&limit=${limit}`;
            api
            .get(endpoint)
            .then(resolve)
            .catch(reject);
        });
    },

    delete(type, id) {
        return new Promise((resolve, reject) => {
            const service = '/ms/notifications/v1/';
            let path = '';
            switch (type){
                case 'mine':
                    path ='notifications';
                    break;
                case 'sales':
                    path ='notifications';
                    break;
                case 'updates':
                    path ='updates';
                    break;
            }
            const endpoint = `${service}${path}/${id}`;
            api
            .delete(endpoint)
            .then(resolve)
            .catch(reject);
        });
    },

    post(type) {
        return new Promise((resolve, reject) => {
            const service = '/ms/notifications/v1/';
            let path = '';
            switch (type){
                case 'mine':
                    path ='notifications';
                    break;
                case 'sales':
                    path ='notifications/sales';
                    break;
                case 'updates':
                    path ='updates';
                    break;
            }
            const endpoint = `${service}${path}/mark-as-read`;
            api
            .post(endpoint)
            .then(resolve)
            .catch(reject);
        });
    },

    put(type, id, payload) {
        return new Promise((resolve, reject) => {
            const service = '/ms/notifications/v1/';
            let path = '';
            switch (type){
                case 'mine':
                    path ='notifications';
                    break;
                case 'sales':
                    path ='notifications';
                    break;
                case 'updates':
                    path ='updates';
                    break;
            }
            const endpoint = `${service}${path}/${id}`;
            api
            .put(endpoint, payload)
            .then(resolve)
            .catch(reject);
        });
    },

    
}